import { ModelBase } from 'store/model-base';

export class CmsDeviceReturn extends ModelBase {
    public static storeName: string = 'cmsDeviceReturn';

    public landing: CmsExchangeReturnLanding;
    public about: CmsDeviceReturnStep;
    public prep: CmsDeviceReturnStep;
    public helpModal: CmsDeviceReturnHelpModal;
    public returnRequestFailModal: CmsReturnRequestFailModal;
    public confirmation: CmsDeviceReturnConfirmation;
    public breadcrumb: CmsDeviceReturnBreadcrumb;
}
